import script from "./AttachmentPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachmentPreview.vue?vue&type=script&setup=true&lang=js"

import "./AttachmentPreview.vue?vue&type=style&index=0&id=5508d660&lang=css"

const __exports__ = script;

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/.pnpm/vue-cli-plugin-quasar@5.0.2/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner});
